import React, { FC, memo } from 'react';
import classnames from 'classnames';

export type IconType =
  | 'close'
  | 'down-arrow'
  | 'favor'
  | 'up-arrow'
  | 'left-arrow'
  | 'right-arrow'
  | 'search'
  | 'plus'
  | 'user'
  | 'checked'
  | 'message'
  | 'favor-hollow';

interface IconProps {
  type: IconType;
  className?: string;
}

export const Icon: FC<IconProps> = memo(({ type, className }) => {
  return <span className={classnames('iconfont', `icon-${type}`, className)} />;
});
